
const jobPlugin = store => {
  store.subscribe((mutation, /*state*/) => {
    
    

    if (mutation.type === 'JobHub/JobUpdater/INCREMENT_UPADTE_TOTALS_TRIGGER') {
      store.dispatch("JobHub/JobUpdater/AutoUpdateOrderTotals")
    }
    if (mutation.type === 'JobHub/JobUpdater/INCREMENT_UPADTE_ORDER_TRIGGER') {
      store.dispatch("JobHub/JobUpdater/AutoUpdateCompleteOrder")
    }
  })
}
export default jobPlugin;
